import { render, staticRenderFns } from "./CatDatatable.vue?vue&type=template&id=dbfac0b4"
import script from "./CatDatatable.vue?vue&type=script&lang=js"
export * from "./CatDatatable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports